import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import '@jaymathew/ui-shared/apis/FirebaseUtilities/FirebaseConfig'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as React from 'react'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import Routes from 'routes/routes'

// register bugsnag
Bugsnag.start({
	apiKey: 'f0953a9407e1fa3f9ecd7cf483cda61b',
	plugins: [new BugsnagPluginReact()],
	enabledReleaseStages: ['production', 'staging'],
	releaseStage: process.env.REACT_APP_ENV,
})
// wrap your entire app tree in the ErrorBoundary provided
const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)

export const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
	<ErrorBoundary>
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<Routes />
			</QueryClientProvider>
		</StrictMode>
	</ErrorBoundary>,
)
